import React, { useState, useEffect } from "react";
import { Spinner, Container, Row, Col, Table, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { apiUrl, businessName } from "../../utils/consts";
import { withRouter } from "react-router";
import { formatMoney } from "../../utils/formatMoney";
import moment from "moment";
const select = (state) => {
  return {
    userId: state.auth.userId,
    token: state.auth.token,
  };
};

function ConnectedPayrollDeductions(props) {
  const { token, userId } = props;

  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [paymentToApprove, setPaymentToApprove] = useState("");
  const [approvingPayment, setApprovingPayment] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const handleApprovePayment = async (payment) => {
    setPaymentToApprove(payment._id);
    setApprovingPayment(true);
    const paymentProm = await fetch(
      `${apiUrl}/payments/approve_payroll_deduction`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
          paymentId: payment._id,
        }),
      }
    );
    const paymentResp = await paymentProm.json();
    if (paymentResp.success) {
      setPaymentToApprove("");
      setApprovingPayment(false);
      let newPayments = [];
      payments.map((item) => {
        if (item._id === payment._id) {
          item.status = "APPROVED";
        }
        newPayments.push(item);
      });
      setPayments(newPayments);
    } else {
      setPaymentToApprove("");
      setApprovingPayment(false);
    }
  };

  const getData = async () => {
    setLoading(true);

    const paymentsProm = await fetch(
      `${apiUrl}/payments/get/payroll_deductions`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId,
          token,
          businessName,
        }),
      }
    );

    const paymentsResp = await paymentsProm.json();
    if (paymentsResp.success) setPayments(paymentsResp.payments);

    setLoading(false);
  };

  if (loading) {
    return (
      <div className="admin-users-component">
        <div className="center">
          <Spinner variant="primary" animation="grow" />
        </div>
      </div>
    );
  }
  return (
    <Container>
      <Row>
        <Col>
          <h1>Descuentos de Nómina</h1>

          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Monto</th>
                <th>Nombre</th>
                <th>Documento</th>
                <th>Estado</th>
                <th>Fecha</th>
                <th>Ayuda</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>${formatMoney(item.amount)}</td>
                  <td>{item.descuentoNominaInfo.userName}</td>
                  <td>{item.descuentoNominaInfo.userDocument}</td>
                  <td>
                    {item.status === "PENDING"
                      ? "Pendiente"
                      : item.status === "APPROVED"
                      ? "Aprobado"
                      : item.status}
                  </td>
                  <td>{moment(item.dateCreated).format("YYYY-MM-DD")}</td>
                  <td>{item.requestedBenefitName}</td>
                  {item.status === "PENDING" && (
                    <td>
                      <Button
                        disabled={approvingPayment}
                        onClick={() => handleApprovePayment(item)}
                      >
                        {approvingPayment && paymentToApprove === item._id ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Aprobar"
                        )}
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

const PayrollDeductions = connect(select)(ConnectedPayrollDeductions);

export default withRouter(PayrollDeductions);
